<mat-form-field appearance="outline">
  <mat-label> {{placeholder}} </mat-label>
  <mat-select placeholder="{{placeholder}}" [formControl]="fc" multiple [required]="required">
    <mat-option *ngFor="let option of failureReasonOptions" [value]="option.code">{{option.name}}{{option.externalCode ? ' - ' + option.externalCode : ''}}</mat-option>
  </mat-select>
</mat-form-field>